import { useState } from 'react';
import {
	InsuranceReportsWhereInput,
	PaginationOrderHow,
	useLazyInsuranceReportsQuery,
} from '../../../graphql/graphql';

export default function useInsuranceReports() {
	const [getInsuranceReportsQuery, { data, isLoading }] =
		useLazyInsuranceReportsQuery();
	const [page, setPage] = useState(1);

	const getInsuranceReports = (patientId: string, workplaceId: string) => {
		getInsuranceReportsQuery({
			where: {
				patientId,
			},
			skip: (page - 1) * 20,
			order: {
				key: 'insurance_report.reported_at',
				how: PaginationOrderHow.Desc,
			},
		});
	};

	const getFlatInsuranceReports = (filter: InsuranceReportsWhereInput) => {
		getInsuranceReportsQuery({
			where: filter,
			skip: (page - 1) * 20,
			order: {
				key: 'insurance_report.reported_at',
				how: PaginationOrderHow.Desc,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getInsuranceReports,
		getFlatInsuranceReports,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
